<template>
  <div class="category-management-container">
    <!-- 面包屑导航 - 响应式调整 -->
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="breadcrumb-item">系统管理</el-breadcrumb-item>
        <el-breadcrumb-item class="breadcrumb-item">栏目管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-divider></el-divider>

    <!-- 表格容器 - 支持横向滚动 -->
    <div class="as-container">
      <avue-crud ref="crud" style="width: 100%"
                 :data="tableData"
                 :option="option"
                 :page.sync="option.page"
                 :table-loading="tableLoading"
                 :search.sync="search"
                 @on-load="onLoad"
                 @search-change="searchChange"
                 @search-reset="resetChange"
                 :cell-style="cellStyleHandler"
      >
        <!-- 操作列 - 移动端优化 -->
        <template slot="menu" slot-scope="{row}">
          <el-button size="mini" type="primary" class="table-btn edit-btn" @click="openOperatingSpace(row)">编辑</el-button>
          <el-button size="mini" type="primary" class="table-btn add-btn" @click="addChild(row)">子集</el-button>
          <el-button
              size="mini"
              type="danger"
              class="table-btn delete-btn"
              @click="rowDelete(row.id)"
              :style="{display: successInfo && successInfo.adminFlag ?'':'none'}"
          >
            删除
          </el-button>
        </template>

        <!-- 左侧按钮区 - 响应式调整 -->
        <template slot="menuLeft">
          <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              class="add-main-btn"
              @click.stop="openOperatingSpace()"
          >
            新增
          </el-button>
        </template>

        <!-- 状态列自定义模板 -->
        <template slot-scope="scope" slot="status">
          <el-tag :type="scope.row.status ? 'success' : 'danger'" class="status-tag">
            {{ scope.row.status ? '显示' : '隐藏' }}
          </el-tag>
        </template>
      </avue-crud>
    </div>

    <!-- 空数据提示 - 响应式调整 -->
    <div v-if="tableData.length === 0 && !tableLoading" class="empty-data">
      <i class="el-icon-s-empty empty-icon"></i>
      <div class="empty-text">暂无栏目数据</div>
      <el-button type="primary" size="small" class="empty-add-btn" @click="openOperatingSpace()">新增栏目</el-button>
    </div>

    <!-- 加载状态 -->
    <div v-if="tableLoading" class="loading-empty">
      <el-skeleton :rows="isMobile ? 5 : 10" active></el-skeleton>
    </div>

    <!-- 新增或修改弹窗 - 响应式尺寸 -->
    <el-dialog
        :title="category.id ? '修改栏目' : '新增栏目'"
        :width="dialogWidth"
        :visible.sync="operatingSpace"
        :close-on-click-modal="false"
        :before-close="closeOperatingSpace"
        class="custom-dialog"
    >
      <el-form
          ref="categoryForm"
          :rules="dataRule"
          :model="category"
          :label-width="formLabelWidth"
          class="form-container"
      >
        <el-form-item v-if="category.id" label="ID">
          <el-input v-model="category.id" disabled class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="title">
          <el-input v-model="category.title" class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
              v-model="category.sort"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              class="form-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select
              ref="selectStatus"
              v-model="category.status"
              placeholder="选择状态"
              clearable
              class="form-select"
          >
            <el-option
                v-for="item in statusData"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="inputVisible" label="父级" prop="parentName">
          <el-input v-model="category.parentName" class="form-input"></el-input>
        </el-form-item>
        <el-form-item class="form-actions">
          <el-button size="small" class="form-btn cancel-btn" @click="resetForm('categoryForm')">重置</el-button>
          <el-button size="small" type="primary" class="form-btn confirm-btn" @click="submitForm">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {getLocal} from "@/utils/localstorage";

export default {
  name: "category",
  data() {
    return {
      viewVisible: false,
      inputVisible: false,
      tableData: [],
      statusData: [{
        value: "1",
        label: "显示"
      }, {
        value: "0",
        label: "隐藏"
      }],
      Userinfo: {},
      operatingSpace: false, // 操作弹窗
      successInfo: {},
      tableLoading: false, // 表格加载状态
      screenWidth: window.innerWidth, // 屏幕宽度
      page: {
        "currentPage": 1,
        "pageSize": 5,
        "total": 0
      },
      category: {id: '', parentId: 0, sort: 0, parentName: ''},
      option: {
        searchIndex: 3,
        searchIcon: true,
        border: true,
        menuWidth: 250, // 操作列宽度，移动端自适应
        menuTitle: "操作",
        addBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: '标题',
            prop: 'title',
            search: true,
            searchOrder: 1,
            cellStyle: () => ({ 'background-color': '#f5f7fa' })
          },
          {
            label: '排序',
            prop: 'sort',
            search: false,
            type: 'number',
            width: 100,
            sortable: true
          },
          {
            label: '状态',
            prop: 'status',
            search: true,
            width: 100,
            type: 'select',
            searchOrder: 1,
            dicData: [{
              value: "1",
              label: "显示"
            }, {
              value: "0",
              label: "隐藏"
            }]
          },
        ],
        headerCellStyle: () => ({
          'background-color': '#f5f7fa',
          'color': '#606266',
          'font-weight': '600'
        }),
        stripe: true,
        index: true,
        indexLabel: '序号',
        indexWidth:'60',
        page: {
          layout: 'total, prev, next', // 默认给移动端布局，会被计算属性覆盖
          total: 0,
          currentPage: 1,
          pageSize: 5,
          pageSizes: [5, 20, 50, 100]
        }
      },
      dataRule: {
        title: [
          {required: true, message: '请输入名称', trigger: 'blur'},
          {min: 3, max: 30, message: '长度在 3 到 30 个字符', trigger: 'blur'}
        ],
        sort: [
          {required: true, message: '请输入排序', trigger: 'blur'},
          {validator: this.validateSort, trigger: 'blur'}
        ],
        status: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ]
      },
      search: {
        size: 20,
        current: 1
      },
      total: 10,
      debounceTimer: null, // 防抖定时器
      requestCount: 0 // 请求计数器
    }
  },
  computed: {
    // 判断是否为移动端
    isMobile() {
      return this.screenWidth < 768;
    },
    // 对话框宽度
    dialogWidth() {
      return this.isMobile ? '90%' : '500px';
    },
    // 表单标签宽度
    formLabelWidth() {
      return this.isMobile ? '80px' : '120px';
    },
    // 动态分页布局 - 核心优化：移动端只保留总数、上一页、下一页
    paginationLayout() {
      return this.isMobile ? 'total, prev, next' : 'total, sizes, prev, pager, next, jumper';
    }
  },
  watch: {
    // 监听设备类型变化，强制更新分页布局
    isMobile(newVal) {
      this.option.page.layout = this.paginationLayout;
      // 强制刷新表格分页组件
      this.$nextTick(() => {
        if (this.$refs.crud && this.$refs.crud.pagination) {
          this.$refs.crud.pagination.layout = this.paginationLayout;
        }
      });
    },
    // 监听屏幕宽度变化，调整操作列宽度
    screenWidth(newVal) {
      this.option.menuWidth = newVal < 768 ? 180 : 250;
    }
  },
  mounted() {
    this.loginValidate();
    // 初始化分页布局
    this.option.page.layout = this.paginationLayout;
    this.loadData();

    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 处理窗口大小变化
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    // 单元格样式处理
    cellStyleHandler({ row, column, rowIndex, columnIndex }) {
      return {
        padding: this.isMobile ? '6px 8px' : '8px 10px',
        fontSize: this.isMobile ? '12px' : '14px'
      };
    },
    // 登录验证
    loginValidate() {
      if (localStorage.getItem('successInfo')) {
        this.successInfo = JSON.parse(getLocal("successInfo"));
      } else {
        this.$message.warning('登录过期');
        this.$router.push('/')
      }
    },
    // 加载数据（带防抖处理）
    loadData(params = {}, force = false) {
      this.tableLoading = true;

      if (this.debounceTimer) clearTimeout(this.debounceTimer);

      const tempParams = { ...this.search, ...params };
      if (!params.isSearch) {
        tempParams.parentId = 0;
      }

      const debounceTime = this.isMobile ? 200 : 300;

      if (!force) {
        this.debounceTimer = setTimeout(() => {
          this._executeLoadData(tempParams);
        }, debounceTime);
        return;
      }

      this._executeLoadData(tempParams);
    },
    // 执行数据加载的具体逻辑
    async _executeLoadData(params) {
      const requestId = ++this.requestCount;
      try {
        const currentPage = Math.max(1, params.currentPage || this.page.currentPage);
        const pageSize = Math.max(1, params.pageSize || this.page.pageSize);

        if (requestId !== this.requestCount) return;

        let loadParams = {
          current: currentPage,
          size: this.isMobile ? Math.min(pageSize, 10) : pageSize // 移动端限制每页数量
        };
        Object.keys(params).forEach(key => {
          if (key !== 'current' && key !== 'size' && key !== 'isSearch' && params[key] !== '') {
            loadParams[key] = params[key];
          }
        });

        const res = await this.$api.categoryApi.getList(loadParams);

        if (res.code === 200) {
          const result = res.data;
          this.page = {
            ...this.page,
            currentPage,
            pageSize: loadParams.size,
            total: result.total
          };
          this.tableData = result.records || [];

          // 同步更新分页组件的总条数
          this.option.page.total = result.total;
        } else {
          this.$message.error('加载数据失败：' + (res.message || '请稍后再试'));
          this.tableData = [];
        }
      } catch (error) {
        this.$message.error('加载数据失败：' + (error.message || '请稍后再试'));
        this.tableData = [];
      } finally {
        this.tableLoading = false;
      }
    },
    // 排序验证
    validateSort(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        return callback(new Error('排序值为必填项，请输入数字'));
      }

      const numValue = Number(value);
      if (isNaN(numValue)) {
        return callback(new Error('请输入有效的数字格式'));
      }

      if (numValue < 0) {
        return callback(new Error('排序值不能小于0'));
      }

      callback();
    },
    // 重置表单
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$nextTick(() => {
          this.$refs[formName].resetFields();
          if (this.category.id) {
            this.$refs[formName].setFieldsValue(this.category);
          }
        });
      }
    },
    // 搜索条件变化处理
    searchChange(params, done) {
      params.isSearch = true;
      Object.assign(this.search, params);
      this.loadData({...this.search, currentPage: 1}, true);
      done(params);
    },
    // 重置搜索条件方法
    resetChange() {
      this.search = {
        size: this.page.pageSize,
        current: 1
      };
      this.loadData(this.search, true);
    },
    // 删除记录
    rowDelete(id) {
      this.$confirm('确定删除这条记录吗？', '确认信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: this.isMobile
      }).then(() => {
        return this.$api.categoryApi.deleteData(id);
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除成功！');
          this.loadData({}, true);
        } else {
          throw new Error(res.message || '删除失败');
        }
      }).catch((err) => {
        if (err !== 'cancel' && err !== 'close') {
          this.$message.error('删除失败：' + (err.message || '未知错误'));
        }
      });
    },
    // 分页变化处理
    onLoad(page) {
      this.page = page;
      this.loadData({
        currentPage: page.currentPage,
        pageSize: page.pageSize
      });
    },
    // 提交表单
    submitForm() {
      this.$refs['categoryForm'].validate(async (valid) => {
        if (valid) {
          try {
            this.category.status = String(this.category.status);

            let res;
            if (this.category.id) {
              res = await this.$api.categoryApi.updateData(this.category);
            } else {
              res = await this.$api.categoryApi.addData(this.category);
            }

            if (res.code === 200) {
              this.$message.success(res.message || (this.category.id ? '修改成功' : '新增成功'));
              this.closeOperatingSpace();
              this.loadData({}, true);
            } else {
              this.$message.error(res.message || '操作失败');
            }
          } catch (error) {
            this.$message.error('操作失败：' + error.message);
          }
        } else {
          return false;
        }
      });
    },
    // 打开子集页面
    addChild(row) {
      this.category = {id: '', parentId: row.id, parentName: row.title};
      this.$router.push({
        name: 'categoryItem',
        query: {
          parentId: row.id,
          parentName: row.title,
          finished: true
        }
      })
    },
    // 打开操作窗口
    openOperatingSpace(row = null) {
      if (row) {
        this.category = {
          ...row,
          status: String(row.status)
        };
      } else {
        this.category = {
          id: '',
          parentId: 0,
          sort: 0,
          parentName: ''
        };
      }
      this.operatingSpace = true;
    },
    // 关闭操作窗口
    closeOperatingSpace() {
      this.category = {id: '', parentId: 0};
      this.operatingSpace = false;
      this.inputVisible = false;
      this.$nextTick(() => {
        if (this.$refs['categoryForm']) {
          this.$refs['categoryForm'].resetFields();
        }
      });
    },
    // 显示字典值
    showDictValue(val, dicArr) {
      if (val != "" && val !== undefined) {
        return dicArr.filter(item => item.value == val)[0]?.label;
      }
      return '';
    }
  }
}

</script>

<style scoped>
/* 页面整体样式 */
.category-management-container {
  padding: 16px;
  background-color: #f8fafc;
  min-height: 100vh;
}
@media (max-width: 768px) {
  .category-management-container {
    padding: 10px 8px;
  }
}

/* 面包屑样式 */
.breadcrumb {
  margin-bottom: 16px;
}
@media (max-width: 768px) {
  .breadcrumb {
    margin-bottom: 10px;
  }
}

.breadcrumb-item {
  font-size: 14px;
}
@media (max-width: 768px) {
  .breadcrumb-item {
    font-size: 12px;
  }
}

.el-divider {
  margin: 0 0 16px;
}
@media (max-width: 768px) {
  .el-divider {
    margin: 0 0 12px;
  }
}

/* 表格容器样式 */
.as-container {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  padding: 16px;
  margin-bottom: 16px;
}
@media (max-width: 768px) {
  .as-container {
    padding: 10px 6px;
    margin-bottom: 12px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

/* 表格按钮样式 */
.table-btn {
  margin-right: 4px;
  min-width: 40px;
}
@media (max-width: 768px) {
  .table-btn {
    min-width: 44px;
    padding: 4px 6px;
    font-size: 12px;
    margin-right: 3px;
  }
}

.add-main-btn {
  /* 基础样式继承自el-button */
}
@media (max-width: 768px) {
  .add-main-btn {
    min-width: 56px;
    padding: 6px 12px;
  }
}

/* 状态标签样式 */
.status-tag {
  padding: 2px 8px;
  font-size: 12px;
}
@media (max-width: 768px) {
  .status-tag {
    padding: 1px 6px;
    font-size: 11px;
  }
}

/* 表单样式 */
.form-container {
  padding: 16px;
}
@media (max-width: 768px) {
  .form-container {
    padding: 10px 6px;
  }
}

.el-form-item {
  margin-bottom: 18px;
}
@media (max-width: 768px) {
  .el-form-item {
    margin-bottom: 14px;
  }
}

.form-input, .form-select {
  width: 100%;
}
@media (max-width: 768px) {
  .form-input, .form-select {
    min-height: 36px;
  }
}

.form-actions {
  text-align: right;
  margin-top: 20px;
}
@media (max-width: 768px) {
  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
  }
}

.form-btn {
  /* 基础样式继承自el-button */
}
@media (max-width: 768px) {
  .form-btn {
    min-width: 60px;
    padding: 6px 10px;
  }
}

/* 空数据样式 */
.empty-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #909399;
  padding: 20px;
}
@media (max-width: 768px) {
  .empty-data {
    height: 200px;
  }
}

.empty-icon {
  font-size: 64px;
  color: #dcdfe6;
  margin-bottom: 16px;
}
@media (max-width: 768px) {
  .empty-icon {
    font-size: 48px;
    margin-bottom: 12px;
  }
}

.empty-text {
  margin-bottom: 16px;
  font-size: 14px;
}
@media (max-width: 768px) {
  .empty-text {
    font-size: 12px;
    margin-bottom: 12px;
  }
}

/* 加载状态样式 */
.loading-empty {
  padding: 40px 0;
  display: flex;
  justify-content: center;
}
@media (max-width: 768px) {
  .loading-empty {
    padding: 20px 0;
  }
}

/* 分页控件优化 - 核心优化点 */
.el-pagination {
  margin-top: 16px;
  text-align: right;
}
@media (max-width: 768px) {
  .el-pagination {
    margin-top: 12px;
    text-align: center; /* 移动端居中显示 */
    padding: 8px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* 移动端分页按钮放大并增加点击区域 */
.el-pagination__prev, .el-pagination__next {
  /* 基础样式保持默认 */
}
@media (max-width: 768px) {
  .el-pagination__prev, .el-pagination__next {
    width: 40px;
    height: 40px;
    line-height: 40px;
    margin: 0 8px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* 确保移动端只显示需要的分页元素 */
@media (max-width: 768px) {
  /* 强制隐藏不需要的元素 */
  .el-pagination__sizes,
  .el-pagination__jump,
  .el-pagination__pager,
  .el-pagination button:not(.el-pagination__prev):not(.el-pagination__next) {
    display: none !important;
  }

  /* 调整总数显示样式 */
  .el-pagination__total {
    margin-right: 12px;
    font-size: 12px;
    color: #606266;
    white-space: nowrap; /* 防止换行 */
  }

  /* 禁用状态样式优化 */
  .el-pagination__prev.is-disabled,
  .el-pagination__next.is-disabled {
    opacity: 0.6;
    background-color: #f5f5f5;
    color: #c0c4cc;
  }
}

/* 对话框样式优化 */
.custom-dialog .el-dialog__body {
  max-height: 60vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 768px) {
  .custom-dialog .el-dialog__body {
    max-height: 50vh;
    padding: 12px 10px;
  }
}

/* 表格行悬停效果 */
.el-table__row:hover {
  background-color: #f5f7fa !important;
}

/* 按钮美化 */
.el-button {
  border-radius: 4px;
  transition: all 0.3s;
}

.el-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}

@media (max-width: 768px) {
  .el-button:hover {
    transform: translateY(-1px);
  }
}
</style>